import { render } from "./index.vue?vue&type=template&id=18ef1f3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=18ef1f3b&scoped=true&lang=less"

import exportComponent from "C:\\code\\zfb_xf_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ef1f3b"]])

export default __exports__